import { useState } from 'react';
import { cn } from '@/lib/utils';
import { CalendarioPublicacoes } from './calendario-publicacoes';
import { PublicacaoSnapshotDialog } from './publicacao-snapshot-dialog';
import { PublicacoesLista } from './publicacoes-lista';

type Aba = 'lista' | 'calendario';
const ABAS: Array<{ id: Aba; rotulo: string }> = [
  { id: 'lista', rotulo: 'Lista' },
  { id: 'calendario', rotulo: 'Calendário' },
];

/**
 * Secao "Publicacoes" da Formacao (substitui "Ultimas formacoes gravadas"). Lista e calendario leem a mesma API; o snapshot
 * abre no diálogo. Publicacoes sao imutaveis: corrigir = publicar outra.
 */
export function PublicacoesPainel() {
  const [aba, setAba] = useState<Aba>('lista');
  const [abrirId, setAbrirId] = useState<string | null>(null);

  return (
    <section id="historico" aria-label="Publicações" className="rounded-2xl border border-border bg-card">
      <div className="flex flex-wrap items-end justify-between gap-3 border-b border-border px-5 py-4">
        <div>
          <h2 className="text-title font-semibold">Publicações</h2>
          <div className="text-small text-ink-muted">Cada publicação grava um snapshot imutável, com vigência. Para corrigir, publique outra.</div>
        </div>
        <div role="tablist" aria-label="Visão das publicações" className="inline-flex rounded-lg bg-surface-muted p-1">
          {ABAS.map((t) => {
            const ativa = aba === t.id;
            return (
              <button
                key={t.id}
                type="button"
                role="tab"
                id={`aba-publicacoes-${t.id}`}
                aria-selected={ativa}
                aria-controls={`painel-publicacoes-${t.id}`}
                onClick={() => setAba(t.id)}
                className={cn(
                  'rounded-md px-3.5 py-1.5 text-small font-medium transition-colors',
                  ativa ? 'bg-card text-ink shadow-sm' : 'text-ink-muted hover:text-ink',
                )}
              >
                {t.rotulo}
              </button>
            );
          })}
        </div>
      </div>

      <div role="tabpanel" id={`painel-publicacoes-${aba}`} aria-labelledby={`aba-publicacoes-${aba}`}>
        {aba === 'lista' ? <PublicacoesLista onAbrir={setAbrirId} /> : <CalendarioPublicacoes onAbrir={setAbrirId} />}
      </div>

      <PublicacaoSnapshotDialog id={abrirId} onOpenChange={(aberto) => !aberto && setAbrirId(null)} />
    </section>
  );
}
